import React from "react";
import { Box, Typography } from "@mui/material";

const POTION_QUESTS = [
  {
    id: "customer",
    title: "顧客",
    description: "カエデからポーションを\n５個買う",
    eyeCatch: `${process.env.PUBLIC_URL}/potion/quest_customer.jpg`,
    cleared: false,
  },
  {
    id: "omake",
    title: "おまけ",
    description: "ポーションの\nおまけをもらう",
    eyeCatch: `${process.env.PUBLIC_URL}/potion/quest_omake.jpg`,
    cleared: false,
  },
  {
    id: "high_potion",
    title: "ハイポーション",
    description: "ハイポーションを\n作ってもらう",
    eyeCatch: `${process.env.PUBLIC_URL}/potion/quest_hipotion.jpg`,
    cleared: false,
  },
  {
    id: "friend",
    title: "友達",
    description: "カエデから\n連絡をもらう",
    eyeCatch: `${process.env.PUBLIC_URL}/potion/quest_friend.jpg`,
    cleared: false,
  },
];

const styles = {
  header: {
    fontFamily: '"Lexend Giga", sans-serif',
    fontSize: "48px",
    lineHeight: "60px",
    fontWeight: 400,
    color: "#8CB808",
    textAlign: "center",
    textShadow: "0px 0px 10px #FFFFFF, 0px 0px 10px #FFFFFF, 0px 0px 10px #FFFFFF",
  },
  separator: {
    fontFamily: '"Lexend Giga", sans-serif',
    fontSize: "24px",
    lineHeight: "30px",
    fontWeight: 400,
    color: "#E22F00",
    textAlign: "center",
    textShadow: "0px 0px 10px #FFFFFF, 0px 0px 10px #FFFFFF, 0px 0px 10px #FFFFFF",
    transform: "rotate(90deg)",
  },
  card: {
    boxSizing: "border-box",
    width: "342px",
    height: "162px",
    border: "1px solid #13433A",
    boxShadow: "0px 0px 10px 1px #FFFFFF",
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",
  },
  eyeCatch: {
    width: "170px",
    height: "160px",
    objectFit: "cover",
    flexShrink: 0,
  },
  cardContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
    padding: "8px",
  },
  questTitle: {
    fontFamily: '"Kaisei Decol", serif',
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "35px",
    textAlign: "center",
    letterSpacing: 0,
    color: "#13433A",
    whiteSpace: "nowrap",
  },
  questDescription: {
    fontFamily: '"Kiwi Maru", serif',
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "22px",
    textAlign: "center",
    letterSpacing: "0.1em",
    color: "#13433A",
    whiteSpace: "pre-line",
  },
  statusBadge: {
    boxSizing: "border-box",
    border: "1px solid #13433A",
    borderRadius: "20px",
    filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
    padding: "2px 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  statusText: {
    fontFamily: '"Kaisei Decol", serif',
    fontWeight: 700,
    fontSize: "11px",
    lineHeight: "35px",
    textAlign: "center",
    letterSpacing: "0.1em",
    color: "#13433A",
  },
  footer: {
    fontFamily: '"Noto Sans JP", sans-serif',
    fontWeight: 400,
    fontSize: "15px",
    lineHeight: "30px",
    textAlign: "center",
    letterSpacing: "0.1em",
    color: "#13433A",
    WebkitTextStroke: "4px #FFFFFF",
    paintOrder: "stroke fill",
  },
};

function QuestCard({ quest }) {
  return (
    <Box sx={styles.card}>
      <Box
        component="img"
        src={quest.eyeCatch}
        alt={quest.title}
        sx={styles.eyeCatch}
      />
      <Box sx={styles.cardContent}>
        <Typography sx={styles.questTitle}>
          {quest.title}
        </Typography>
        <Typography sx={styles.questDescription}>
          {quest.description}
        </Typography>
        <Box sx={{
          ...styles.statusBadge,
          ...(quest.cleared ? {
            backgroundColor: "#8CB808",
            borderColor: "#8CB808",
          } : {}),
        }}>
          <Typography sx={{
            ...styles.statusText,
            ...(quest.cleared ? { color: "#ffffff" } : {}),
          }}>
            {quest.cleared ? "クリア" : "未クリア"}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default function PotionQuestSection() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        width: "100%",
        mt: 8,
      }}
    >
      <Typography sx={{...styles.header, color: "#E22F00"}}>
        <span style={{ color: "#8CB808" }}>Q</span>uest
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
          width: "100%",
        }}
      >
        {POTION_QUESTS.map((quest, index) => (
          <React.Fragment key={quest.id}>
            <QuestCard quest={quest} />
            {index === 1 && (
              <Typography sx={styles.separator}>
                ・<span style={{ color: "#8CB808" }}>・</span>・
              </Typography>
            )}
          </React.Fragment>
        ))}
      </Box>

      <Typography sx={styles.footer}>
        🧪クエスト20以上！🧪
      </Typography>
    </Box>
  );
}
